/* eslint-disable sort-keys, consistent-return */
import {HYDRATE} from 'next-redux-wrapper';
import {createApi} from '@reduxjs/toolkit/query/react';
import {customBaseQuery} from 'core/redux/store/api/utils';

export const baseApi = createApi({
    tagTypes: [
        'Cart',
        'WishList',
        'Review',
        'ProductList',
        'ExpressOrder',
        'FacetFilters',
        'WishlistNew',
        'Product/Recommendations',
        'Profile',
        'User',
        'Banners',
        'PersonalOffers',
    ],
    baseQuery: customBaseQuery,
    endpoints: () => ({}),
    extractRehydrationInfo(action, {reducerPath}) {
        if (action.type === HYDRATE) {
            const payload = (action as any).payload as Record<string, unknown> | undefined;
            const apiState = payload?.[reducerPath] as
                | {
                      queries?: unknown;
                      mutations?: unknown;
                      provided?: {tags?: unknown; keys?: unknown} | Record<string, unknown>;
                  }
                | undefined;

            if (!apiState) {
                return undefined;
            }

            const invalidationState = apiState.provided;
            const providedTags =
                invalidationState && 'tags' in invalidationState ? invalidationState.tags : invalidationState;

            return {
                queries: apiState.queries,
                mutations: apiState.mutations,
                provided: providedTags,
            } as any;
        }

        return undefined;
    },
});
